<app-info-modal #infoModal actionLabel="Continue" i18n-actionLabel [backdrop]="true" [showX]="true">
  <div class="text-center"><i class="bi bi-info-circle"></i></div>
  <div class="text-center" i18n>You can't place orders on this consultant's replicated site!</div>
</app-info-modal>
